import { useEffect, useState } from "react";

/**
 * Custom hook to track window size minus header/sidebar offsets.
 * @param {number} offsetWidth  - pixels to subtract from window.innerWidth (default 160)
 * @param {number} offsetHeight - pixels to subtract from window.innerHeight (default 60)
 */
function useWindowSize(offsetWidth = 160, offsetHeight = 60) {
  // Safe initial value for SSR
  const getSize = () => ({
    width: typeof window !== "undefined" ? window.innerWidth - offsetWidth : 1200,
    height: typeof window !== "undefined" ? window.innerHeight - offsetHeight : 700,
  });

  const [windowSize, setWindowSize] = useState(getSize);

  useEffect(() => {
    const handleResize = () => setWindowSize(getSize());
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
    // eslint-disable-next-line
  }, [offsetWidth, offsetHeight]);

  return windowSize;
}

export default useWindowSize;